import { defineStore } from 'pinia';
import { computed } from 'vue';
import type { ProductGroup } from '../domain/productGroup';
import { useEntityStore } from '../../../common/composables/entityStore';

export const useProductGroupStore = defineStore('product-groups', () => {
  const {
    add,
    getById: getEntityById,
    getOrThrow,
    remove,
    merge,
    clear,
    changed,
    list,
  } = useEntityStore<ProductGroup>({
    eventName: 'product-group-changed',
    getEntityId(group) {
      return group.id;
    },
    updateEntity(dest, src) {
      dest.id = src.id;
      dest.name = src.name;
      dest.color = src.color;
      dest.description = src.description;
      dest.productType = src.productType;
    },
    hasChanged(existing, incoming) {
      return JSON.stringify(existing) !== JSON.stringify(incoming);
    },
  });

  function getById(id: string | null) {
    if (id === null) return null;
    return getEntityById(id) ?? null;
  }

  const sortedByName = computed(() => {
    const clone = Array.from(list.value);
    clone.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));
    return clone;
  });

  return {
    changed,
    groups: computed(() => list.value),
    sortedByName,
    add,
    remove,
    merge,
    clear,
    getById,
    getOrThrow,
  };
});
